import React from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { Container, Box, Typography, Button } from "@mui/material";
import { t } from "@lingui/macro";
import * as klaro from "klaro";
import CookieIcon from "@mui/icons-material/Cookie";


const MyProfile = () => {
  const { user, customData } = useUser();
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      {/* Page Title */}
      <Typography variant="h4" gutterBottom>
        {t`My Profile`}
      </Typography>

      {/* User Information */}
      <Typography variant="body1">
        <strong>{t`Email:`}</strong> {user.email}
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        <strong>{t`Username:`}</strong> {customData?.Username || user.displayName}
      </Typography>

      {/* Story Action Buttons */}
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/mystories")}
        >
          {t`My Stories`}
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => navigate("/mystories/new")}
        >
          {t`Start a New Story`}
        </Button>
      </Box>

      {/* Cookie Settings Button */}
      <Box sx={{ mt: 3 }}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<CookieIcon />}
          onClick={() => klaro.show()}
        >
          {t`Cookie Settings`}
        </Button>
      </Box>
    </Container>
  );
};

export default MyProfile;
